<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Expiring EPayments Report",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Expiring EPayments Report",
            items: [
               {
                  text: "Expiring EPayments Report",
                  active: true,
               },                   
            ],
            vehicles: [],

            type: 2,
            service_id: 2,
            response_service_id: 2,

            loading: false,
            active_page_url: '',

            token: '',
            errors: {},
            password: "",
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchVehicles();
      },

      methods: {    

         hideModal(modal) {
            this.$refs[modal].hide();
         },         

         fetchVehicles() {
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            var data = JSON.stringify({             
               
               "type": this.type,
               "service_id": this.service_id,
            });
            this.loading = true;  
            
            let url = "/api/hub/reports/hubEPayments";

            this.errors = {};
            
            
            this.$axios
               .post(url, data, config)
               .then((res) => {
                  var responseData = res.data.data;
                  
                  this.vehicles = responseData.vehicles;
                  this.response_service_id = this.service_id;
                  //console.log(this.vehicles);
               })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {

                        if(typeof error.response.data.message === 'object') {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }    
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         checkPassword() {
            this.getToken();

            let url = "/api/hub/profile/checkReportPassword";   
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               }
            };
            var data = JSON.stringify({
               "password": this.password
            });
            
            this.$axios
            .post(url, data, config)
            .then((response) => {
               if (response.data.status) {
                  this.exportVehicles();
                  this.$swal("", response.data.message, "success");
                  this.hideModal("password-modal");

               } else {
                  this.$swal("", "Incorrect Password", "error");
               }
            })
            .catch((error) => {
               //console.log(error);
               if (error.response) {
                  
                  this.errors = error.response.data.message;
                  if (error.response.data) {
                     this.$swal("", "Something went wrong", "error");   
                  } else {
                     this.errorMessage = error.message;
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.errorMessage = error.message;
                  this.$swal("", "Something went wrong", "error");
               }
               
            });
         },

         exportVehicles() {

            this.getToken();
            let url = "/api/hub/reports/exportHubEPayments";   
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
               responseType: "arraybuffer",
            };
            var data = JSON.stringify({
               "type": this.type,
               "service_id": this.service_id,
            });
            

            this.$axios
            .post(url, data, config)
            .then((response) => {
               //console.log(response);
               let blob = new Blob([response.data], { type: "application/pdf" });
               let link = document.createElement("a");
               link.href = window.URL.createObjectURL(blob);
              
               let filename = "epayments-expiring.xlsx";

               link.download = filename;
               link.click();
                     
            })
            .catch((error) => {
               //console.log(error);
               if (error.response) {
                  //console.log(error.response);
                  
                  if (error.response.data.message) {
                     
                     this.errors = error.response.data.message;
                     //console.log(this.errors);

                  } else {
                     console.log('Error');
                  }
               } else {
                  console.log('Error');
               }
            });
         }, 

         getToken() {
            if (localStorage.getItem('vc_hub')) {
               var vc_hub =  JSON.parse(localStorage.getItem('vc_hub'));
               if(vc_hub.token) {
                  this.token = vc_hub.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },      
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- filters area starts---->
                  <div class="row mb-3">

                     <div class="form-group col-lg-4">
                        <label>Service</label>
                        <select class="form-control" v-model="service_id">
                           <option value="2">Fitness</option>
                           <option value="3">Permit</option>
                           <option value="4">Tax</option>
                           <option value="5">Welfare Fund</option>
                           <option value="6">Registration Renewal</option>
                        </select>
                     </div>
                  </div>

                  <div class="row">
                     <div class="col-12">
                        <button class="btn btn-primary me-2" type="button" @click="fetchVehicles()">View</button>
                        <!-- <button class="btn btn-primary me-2" type="button" v-if="vehicles.length" @click="exportVehicles()">Download</button> -->
                        <button v-b-modal.password-modal class="btn btn-primary me-2" type="button" v-if="vehicles.length">Download</button>
                     </div>
                  </div>
                  <!----- filters area ends---->
               </div>
            </div>

            <div class="card">
               <div class="card-body">                  

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Vehicle</th>
                              <th>Contact</th>  
                              <th>
                                 <span v-if="response_service_id==2">Fitness Expiry</span>                              
                                 <span v-if="response_service_id==4">Tax Expiry</span>
                                 <span v-if="response_service_id==3">Permit Expiry</span>
                                 <span v-if="response_service_id==5">Welfare Fund Renewal</span>
                                 <span v-if="response_service_id==6">Registration Renewal</span>
                              </th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(vehicles.length)">
                           <tr v-for="(vehicle) in vehicles" :key="vehicle.id">
                              <td>{{vehicle.vehicle_number}}</td>
                              <td>{{vehicle.contact_name}}<br>
                                 {{vehicle.contact_mobile_code}} {{vehicle.contact_mobile}}<br>
                                 <span v-if="vehicle.contact_email">{{vehicle.contact_email}}</span>
                              </td>
                              
                              <td>
                                 <span v-if="response_service_id==2">{{vehicle.converted_fitness_expiry}}</span>
                                 <span v-if="response_service_id==4">{{vehicle.converted_tax_expiry}}</span>
                                 <span v-if="response_service_id==3">{{vehicle.converted_permit_expiry}}</span>
                                 <span v-if="response_service_id==5">{{vehicle.converted_welfare_fund_renewal}}</span>
                                 <span v-if="response_service_id==6">{{vehicle.converted_registration_renewal}}</span>
                              </td>
                           </tr>                           
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="3" class="text-center">No expiring epayments found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!---- modal starts ---->
                  <b-modal ref="password-modal" id="password-modal" title="Report Password Verification" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="checkPassword()">  
                        
                        <div class="row"> 
                           <b-form-group class="col-lg-12">
                              <label>Report Password <span class="text-danger">*</span></label>
                              <input class="form-control" type="password" v-model="password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }" />

                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>                           

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">Submit</b-button>
                              <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->
                  
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
